import { render, staticRenderFns } from "./GroupManagement.vue?vue&type=template&id=a9e1ff00&scoped=true&"
import script from "./GroupManagement.vue?vue&type=script&lang=js&"
export * from "./GroupManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9e1ff00",
  null
  
)

export default component.exports